
import {GET_FillSemesters} from '../constants/ActionTypes'

const INIT_STATE = {
    Semesters: null,
    //Message1: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillSemesters:
                return {
                    Semesters: action.body,
                    //Message1:action.msg
                  
                }
        default:
            return state;
    }
}